import { Grid } from "@mui/system";
import { Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import DailyEarningGapsTable, {
  DAILY_EARNING_GAPS_COLUMNS,
} from "./DailyEarningGapsTable";
import { exportRowsToCsv } from "../Utils/anomaliesColumns";
import BrandSearchBar from "../Utils/BrandSearchBar";

const DailyEarningGaps = () => {
  const [choosenBrand, setChosenBrand] = useState<string | null>(null);

  const dailyEarningGapsData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.dailyEarningGapsData,
  );

  const dailyEarningGapsMetadata = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.dailyEarningGapsMetadata,
  );

  const isFetchedForEarningData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.isFetchedForEarningData,
  );

  //-- Extract unique brand names for the search filter
  const brandNames = useMemo(() => {
    const set = new Set<string>();
    (dailyEarningGapsData || []).forEach((r: any) => {
      if (typeof r?.brand_name === "string") set.add(r.brand_name.trim());
    });
    return Array.from(set);
  }, [dailyEarningGapsData]);

  // filter rows by the chosen brand
  const filteredData = useMemo(() => {
    const search = (choosenBrand ?? "").trim().toLowerCase();
    if (!search) return dailyEarningGapsData;
    return (dailyEarningGapsData || []).filter((row: any) =>
      String(row.brand_name ?? "")
        .toLowerCase()
        .includes(search),
    );
  }, [dailyEarningGapsData, choosenBrand]);

  return (
    <>
      <Grid container spacing={2} alignItems="center" px={2} py={1.5}>
        <Grid size={8}>
          <Typography variant="body1" fontSize={18}>
            Daily Earning Gaps in MTD
          </Typography>
        </Grid>
        <Grid size={4}>
          <BrandSearchBar
            dataTrackerForSearch="890"
            brandNames={brandNames}
            chosenBrand={choosenBrand}
            onBrandChange={setChosenBrand}
            dataTrackerForDownload="888"
            onDownload={() =>
              exportRowsToCsv(
                filteredData,
                DAILY_EARNING_GAPS_COLUMNS,
                "daily-earning-gaps-mtd.csv",
              )
            }
            disabled={
              (dailyEarningGapsData?.length ?? 0) === 0 ||
              !isFetchedForEarningData
            }
          />
        </Grid>
      </Grid>
      <DailyEarningGapsTable
        metadata={dailyEarningGapsMetadata}
        rows={filteredData}
      />
    </>
  );
};

export default DailyEarningGaps;
